import script from "./Play.vue?vue&type=script&setup=true&lang=js"
export * from "./Play.vue?vue&type=script&setup=true&lang=js"

import "./Play.vue?vue&type=style&index=0&id=0ab11def&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab11def"]])

export default __exports__